var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-cell',{attrs:{"title":_vm.item.title,"border":_vm.item.border},scopedSlots:_vm._u([{key:"right-icon",fn:function(){return [_c('svg-icon',{attrs:{"icon-class":_vm.item.icon || 'icon_arrow_rig_gray'}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }